import React from "react";
import { Button, Box } from "@mui/material";

const ARROW_ICON_BG =
  "url(\"data:image/svg+xml,%3Csvg width='17' height='14' viewBox='0 0 17 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 9L1 5M1 5L5 1M1 5H12C13.0609 5 14.0783 5.42143 14.8284 6.17157C15.5786 6.92172 16 7.93913 16 9C16 10.0609 15.5786 11.0783 14.8284 11.8284C14.0783 12.5786 13.0609 13 12 13H11' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\")";

export default function GoBackButton({ onClick, sx = {}, ...props }) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      {...props}
      sx={{
        width: "187px",
        height: "50px",
        minWidth: "187px",
        borderRadius: "7px",
        px: "16px",
        gap: "10px",
        textTransform: "none",
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: 1.2,
        backgroundColor: "#0DA3E2",
        color: "#FFFFFF",
        "&:hover": {
          backgroundColor: "#0DA3E2",
          opacity: 0.92,
        },
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          width: "17px",
          height: "14px",
          backgroundImage: ARROW_ICON_BG,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
          flexShrink: 0,
        }}
      />
      Go Back
    </Button>
  );
}
